import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { useCanvasMediaScroll } from '../utils/use-canvas-media-scroll';
import { ScrollImagesContainer } from './scroll-images-container';
import { useFallbackImage } from '../utils/use-fallback-image';
import { useViewbox } from '../utils/use-viewbox';
import { useImagesUrl } from '../utils/use-images-url';
import { Animation, ThemeScroll } from '../FeatureAppTypes';

const ScrollCanvas = styled.canvas<{ height: number; width: number }>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  padding: 0;
  margin: 0;
`;

export interface CanvasProps extends PropsWithChildren {
  position: number;
  backdropSpeed: number;
  animation: Animation;
  theme: ThemeScroll;
}

export const Canvas: React.FC<CanvasProps> = ({
  children,
  position,
  backdropSpeed,
  animation,
  theme,
}) => {
  const ref = React.useRef<HTMLCanvasElement | null>(null);
  const { width, height } = useViewbox();
  const fallbackImage = useFallbackImage(animation.fallback, theme);
  const { alt } = useImagesUrl(animation, theme);
  // Draw images on canvas
  useCanvasMediaScroll({
    backdropColor: process.env.IS_LEGACY
      ? theme.colors.sysColorSurfaceNeutral
      : theme.colors.colorCanvas200,
    backdropSpeed,
    animation,
    position,
    ref,
    theme,
  });

  return (
    <ScrollImagesContainer backgroundImage={fallbackImage || ''}>
      <ScrollCanvas ref={ref} width={width} height={height} role="img" aria-label={alt || ''} />
      {children}
    </ScrollImagesContainer>
  );
};
